<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M18.361 69.815c0-.567-.196-1.013-.587-1.337-.39-.324-.913-.486-1.564-.486h-3.545v3.62h3.545c.668 0 1.193-.157 1.576-.473.383-.316.575-.757.575-1.324"
      />
      <path
        d="M46.353 75.257V58.25h7.628c1.922 0 3.438.494 4.547 1.482 1.125.988 1.687 2.268 1.687 3.839 0 1.571-.562 2.86-1.687 3.863-1.109.989-2.625 1.483-4.547 1.483h-3.228v6.341h-4.4zM35.645 69.45h-2.42l-3.154-4.568v10.375h-4.4V58.25h4.376l4.327 6.536 4.352-6.536h4.351v17.008h-4.376V64.882l-3.056 4.568zm35.562 24.032H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM8.264 75.257V58.25h8.337c1.613 0 2.905.376 3.875 1.13.97.753 1.454 1.81 1.454 3.17 0 .778-.191 1.458-.574 2.041-.383.584-.86 1.005-1.43 1.264.847.194 1.597.689 2.249 1.482.668.81 1.002 1.822 1.002 3.037 0 1.458-.562 2.64-1.687 3.548-1.092.891-2.567 1.336-4.425 1.336h-8.8zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.706-4.773 10.706-10.643V25.19L56.48 0z"
      />
      <path
        d="M55.19 64.87c.383-.3.575-.717.575-1.252 0-.534-.187-.947-.562-1.239-.375-.291-.889-.437-1.54-.437h-2.91v3.377h2.91c.635 0 1.145-.15 1.528-.45M17.224 64.372c.318-.26.477-.616.477-1.07 0-.469-.159-.838-.477-1.105-.318-.267-.745-.4-1.283-.4h-3.276v2.964h3.276c.538 0 .965-.13 1.283-.39M45.776 28.58a2.405 2.405 0 0 0-1.87.69l-3.093 3.099-7.89-7.842a2.406 2.406 0 0 0-1.703-.715 2.404 2.404 0 0 0-1.726.859l-11.99 14.3a2.373 2.373 0 0 0 .303 3.357c.401.333.9.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.402 2.402 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.766-4.796 4.766-2.65 0-4.797-2.134-4.797-4.766 0-2.633 2.148-4.767 4.797-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-bmp',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
